import { api } from '@shared/services/api'
import { url } from 'constants/urls'
import { OffersResponse } from '../../interface/offerInterface'

export const getOffers = async (): Promise<OffersResponse> => {
  const { data } = await api.get<OffersResponse>(url.offers)

  return data
}
